import {
  UPLOAD_FILE_WITH_METHOD,
  POST,
  PUT,
  GET,
} from "../../apiController";

const endpoint = "/admin/courses";

// create course
export const getCourseCertificate = (search = "") => {
  return GET(
    endpoint + `/get_course_certificate${search ? `?search=${search}` : ""}`
  );
};

export const getAllCourseTrainers = () => {
  return GET(endpoint + `/get_trainers`);
};

export const getCourseClassrooms = () => {
  return GET(endpoint + `/classrooms`);
};

export const getCourseCategories = () => {
  return GET(endpoint + `/categories`);
};

export const createNewCourse = (data) => {
  return UPLOAD_FILE_WITH_METHOD(endpoint + `/course/new`, data);
};

//   /course_details_by_id uign payload
export const getCourseDetailsById = (data) => {
  return POST(endpoint + `/course_details_by_id`, data);
};

export const updateCourseDetails = (courseId, data) => {
  return PUT(endpoint + `/course/update/${courseId}`, data);
};

export const getCourseList = (data) => {
  return GET(
    endpoint +
    `/courses?page=${data.page}&limit=${data.limit}&search=${data.search || ""}&status=${
      data.status || "all"
    }`
  );
};
